import { render, staticRenderFns } from "./promotionQRLists.vue?vue&type=template&id=bf8f130e&scoped=true&"
import script from "./promotionQRLists.vue?vue&type=script&lang=js&"
export * from "./promotionQRLists.vue?vue&type=script&lang=js&"
import style0 from "./promotionQRLists.vue?vue&type=style&index=0&id=bf8f130e&scoped=true&lang=css&"
import style1 from "./promotionQRLists.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8f130e",
  null
  
)

export default component.exports